import { Sidebar, Skeleton, SkeletonText } from '@buffer-mono/popcorn'

import styles from './ChannelsSection.module.css'

import type { JSX } from 'react'

/**
 * Loading placeholder for the whole channels group, including its separator
 * and label chrome. It reuses the real section's classes so the swap to
 * loaded content lands on the same geometry.
 */
export function ChannelsSectionGroupSkeleton({
  rows,
}: {
  rows?: number
}): JSX.Element {
  return (
    <Sidebar.Group className={styles.channelsSection}>
      <Sidebar.Separator className={styles.separator} />
      <Sidebar.GroupLabel className={styles.groupLabel}>
        <SkeletonText lines={1} width={64} />
      </Sidebar.GroupLabel>
      <Sidebar.GroupContent className={styles.channelsGroupContent}>
        <ChannelsSectionSkeleton rows={rows} />
      </Sidebar.GroupContent>
    </Sidebar.Group>
  )
}

export function ChannelsSectionSkeleton({
  rows = 5,
}: {
  rows?: number
}): JSX.Element {
  const skeletonIds = Array.from(
    { length: rows },
    (_, rowIndex) => `channel-skeleton-${rowIndex + 1}`,
  )
  return (
    <Sidebar.List aria-label="Channels">
      {skeletonIds.map((skeletonId) => (
        <Sidebar.ListItem key={skeletonId}>
          <Sidebar.ButtonSkeleton
            prefix={<Skeleton width={32} height={32} />}
            size="large"
          >
            <SkeletonText lines={1} width={86} />
          </Sidebar.ButtonSkeleton>
        </Sidebar.ListItem>
      ))}
    </Sidebar.List>
  )
}
